import React from "react";

function ProjectCard({ project }) {
  return (
    <div className="flex flex-1 justify-between items-center my-4 mx-0 py-2 px-0">
      <div className="flex flex-col md:flex-row w-full shadow-md mb-2 p-5">
        <div className="flex flex-col ml-0 mt-3 md:mr-6 w-full md:w-2/3">
          <label className="font-medium text-2xl w-full">{project.title}</label>
          <div className=" m-2 flex">
            {project.demo && (
              <a className="" href={project.demo} target="_blank" rel="noreferrer">
                <div className="flex justify-center items-center bg-yellow-400 text-white w-max py-1 px-2 rounded-md text-base mr-1">
                  <i class="fi-rr-globe text-white"></i>View
                </div>
              </a>
              )}
              {project.github&& (
                <a className="project-link" href={project.github} target="_blank" rel="noreferrer">
                  <div className="flex justify-center items-center bg-yellow-400 text-white w-max py-1 px-2 rounded-md text-base mr-1">
                  <i class="devicon-github-original text-white"></i>Github
                </div>
              </a>
              )}
          </div>
          <p className="mb-3 w-full">{project.about}</p>
          <div className="flex flex-row md:flex-wrap w-full md:max-w-[70%] mb-3">
            {project.tags.map((tag)=> {
              return <label className=" py-1 px-2 bg-yellow-400 rounded-sm mr-2 mb-1 text-white">{tag}</label>;
            })}
          </div>
        </div>
        <div className="flex w-full md:w-1/3">
          <img src={project.image} className="w-full" alt={project.title} />
          {/* <img src={img} className="w-full" /> */}
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;